import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { finalize } from 'rxjs/operators';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

import { UserService } from 'src/app/services/shared/user.service';
import { AppSettingsService, SubdomainEnum } from 'src/app/services/app-settings.service';

@Component({
  selector: 'terra-email-suspend',
  templateUrl: './email-suspend.component.html',
  styleUrls: ['./email-suspend.component.scss']
})
export class EmailSuspendComponent extends OnDestroyMixin implements OnInit {
  isLoading = true;

  // Parameters
  token = '';
  email = '';

  confirmedSuccessful = false;
  confirmedError = false;

  referrerLogo$ = this.appSettingsService.subDomain === SubdomainEnum.GP ? this.userService.gp_referrerLogo$ : this.userService.lp_referrerLogo$;

  constructor(
    private route: ActivatedRoute, 
    private userService: UserService, 
    private titleService: Title,
    private appSettingsService:AppSettingsService) {
    super();
  }

  ngOnInit() {
    this.titleService.setTitle('Account Suspended');
    this.getQueryParameters();
    this.confirm();
  }

  getQueryParameters() {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.email = params.email;
    });
  }

  confirm() {
    this.confirmedError = false;
    this.confirmedSuccessful = false;

    if (this.token && this.email) {
      this.isLoading = true;

      this.userService
        .rejectEmail(this.email, this.token)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          }),
          untilComponentDestroyed(this)
        )
        .subscribe(
          response => {
            this.confirmedSuccessful = true;
          },
          error => {
            this.confirmedError = true;
          }
        );
    }
  }
}
